import logo from "@/assets/kootixli-logo.png";
import gaitVisual from "@/assets/gait-visual.png";

// Contenido de la página del demo (7-ago-2026). Fuente: stages/01_discovery/output/alcance_v2.md
// §1 y §7, y landing/DISENO-DASHBOARD-DEMO.md.
//
// ⚠️ LAS MARCAS DE ESTADO SE QUITARON EL 6-AGO A PETICIÓN DEL CLIENTE — no fue un descuido.
//
// Hasta el 5-ago cada paso del recorrido, cada vista y cada requisito declaraba su ESTADO
// (funcionando hoy / Fase 2 / requiere equipo del cliente) con una insignia visible, más una
// leyenda fija en la cabecera. Neto pidió el 6-ago dejarlas fuera de la muestra conceptual
// porque las lee como indicativos internos del proyecto: "solamente mencionarlos sin los tags
// de las Fases, el requisito de equipo, funcionamiento a hoy".
//
// Lo que NO cambia, y por lo que hay que tener cuidado al editar este archivo: el cliente final
// es gobierno y presentar una maqueta como producto terminado sigue siendo el riesgo más caro
// del proyecto (alcance_v2 §7). Hoy lo único construido y probado sobre video real es la
// identificación por forma de caminar. Sin las insignias, esa distinción vive ahora únicamente
// en la REDACCIÓN de cada descripción y en la banda del centro de mando ("ejemplo de cómo se
// verá"). No suavizar esos textos: son lo último que queda impidiendo que la página afirme de
// más. Si alguien quiere reponer las insignias, es decisión del cliente, no de quien edita.
export const ASSETS = {
  logo,
  gaitVisual,
  heroDrone:
    "https://images.unsplash.com/photo-1504890001746-a9a68eda46e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  cityFeed:
    "https://images.unsplash.com/photo-1711025716267-e75c2a8598da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  fibers:
    "https://images.pexels.com/photos/8640331/pexels-photo-8640331.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  commandCenter:
    "https://images.unsplash.com/photo-1652145595413-0a79398e5888?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

// Recorrido del sistema, de principio a fin (alcance_v2 §7, punto 1). Es la respuesta a
// "qué va a hacer el proyecto", y va numerado porque es una secuencia real.
export const RECORRIDO = [
  {
    n: 1,
    icon: "Camera",
    title: "Cámaras en los accesos",
    desc:
      "En cada entrada del evento se instalan cámaras que graban a la gente al pasar. Cuántos accesos y cuántas cámaras se define con el organizador, y el equipo es suyo.",
  },
  {
    n: 2,
    icon: "Fingerprint",
    title: "Qué se registra de cada persona",
    desc:
      "De cada quien se toma su forma de caminar, que es única como una huella. El rostro, la ropa, los accesorios y el comportamiento son desarrollo nuevo: hoy funciona la caminata.",
  },
  {
    n: 3,
    icon: "Database",
    title: "Base de datos del evento",
    desc:
      "Todo lo capturado en los accesos forma una base que vive únicamente durante el evento. Es la que permite, más tarde, buscar a alguien entre miles de personas.",
  },
  {
    n: 4,
    icon: "MonitorDot",
    title: "Centro de mando",
    desc:
      "Una sola pantalla desde donde se monitorea el evento completo. El operador prende la vista que necesita. Es la parte de abajo de esta página.",
  },
  {
    n: 5,
    icon: "Radar",
    title: "Drones durante el evento",
    desc:
      "Al arrancar el evento los drones suman su vista aérea a la del centro de mando. El equipo de vuelo es del cliente y quien decide siempre es una persona, nunca el sistema.",
  },
  {
    n: 6,
    icon: "Trash2",
    title: "Borrado al cerrar, con constancia",
    desc:
      "Al terminar el evento la base se elimina, y se entrega el comprobante de que se borró. No se guardan datos de los asistentes después del evento.",
  },
];

// Las cuatro vistas del centro de mando (alcance_v2 §7, punto 2). Se prenden por botón.
export const VISTAS = [
  {
    id: "marcha",
    icon: "Footprints",
    title: "Identificación por forma de caminar",
    desc:
      "Reconoce a una persona por cómo camina, aunque traiga el rostro cubierto. Es lo único de esta pantalla que ya está construido y probado sobre video real.",
  },
  {
    id: "termica",
    icon: "Thermometer",
    title: "Visión térmica e infrarroja",
    desc:
      "Ver de noche, entre humo y en zonas sin luz. Necesita que las cámaras o los drones traigan el sensor térmico.",
  },
  {
    id: "contingencias",
    icon: "Flame",
    title: "Avisos de contingencias",
    desc:
      "Aviso temprano de un incendio, una riña o una explosión, con la zona señalada. El sistema avisa; la decisión de qué hacer siempre es de una persona.",
  },
  {
    id: "flujos",
    icon: "Waves",
    title: "Flujos de gente y aglomeraciones",
    desc:
      "Por dónde se mueve la gente, dónde se está formando un cuello de botella y aviso temprano antes de que una zona se sature.",
  },
];

// Privacidad y manejo de datos (alcance_v2 §7, punto 3). Alineado al contrato v2:
// Cláusula Décima Segunda + Exclusión 9.
export const CONSTRAINTS = [
  {
    icon: "FileCheck2",
    title: "Aviso y consentimiento en los accesos",
    desc:
      "Antes de entrar, cada asistente sabe qué se captura, para qué y por cuánto tiempo. Nosotros entregamos los textos y el mecanismo; el aviso lo coloca el organizador.",
    tag: "Antes de entrar",
  },
  {
    icon: "Landmark",
    title: "El organizador responde por los datos",
    desc:
      "El organizador del evento es el responsable legal del tratamiento: define para qué se usan y recaba el consentimiento. Zulunity solo opera el sistema siguiendo sus instrucciones.",
    tag: "Responsabilidad definida",
  },
  {
    icon: "Clock",
    title: "La base dura lo que dura el evento",
    desc:
      "Los datos existen mientras el evento ocurre y se eliminan al cerrarlo. No hay base histórica ni perfiles que se acumulen de un evento a otro.",
    tag: "Temporalidad estricta",
  },
  {
    icon: "Hand",
    title: "La decisión siempre es de una persona",
    desc:
      "El sistema señala y ordena información. No detiene a nadie, no toma decisiones de seguridad y no pilota. Es apoyo a la decisión de un operador humano.",
    tag: "Nunca decide solo",
  },
];

// La cadena del evento, de la cámara al borrado. Reemplaza la cadena del dron (Jetson, RF,
// estación terrestre), que en el alcance v2 es fase posterior.
export const ARCH_FLOW = [
  { icon: "Camera", title: "Cámaras en accesos", sub: "Equipo del cliente" },
  { icon: "Fingerprint", title: "Registro de la persona", sub: "Forma de caminar" },
  { icon: "Database", title: "Base del evento", sub: "Temporal, solo el evento" },
  { icon: "Cpu", title: "Motor de identificación", sub: "Búsqueda contra la base" },
  { icon: "MonitorDot", title: "Centro de mando", sub: "Una pantalla, cuatro vistas" },
  { icon: "Trash2", title: "Borrado con constancia", sub: "Comprobante de eliminación" },
];

export const USE_CASES = [
  {
    code: "CU-01",
    title: "Registrar a quien entra",
    desc:
      "Capturar la forma de caminar de cada persona en los accesos y sumarla a la base del evento.",
  },
  {
    code: "CU-02",
    title: "Buscar a alguien entre miles",
    desc:
      "Si ocurre un incidente, buscar a esa persona contra la base que ya se construyó en las entradas.",
  },
  {
    code: "CU-03",
    title: "Aforo y saturación por zona",
    desc:
      "Cuánta gente hay en cada zona y avisar antes de que una se sature. Es lo que previene una estampida.",
  },
  {
    code: "CU-04",
    title: "Aviso de contingencia",
    desc:
      "Señalar un incendio, una riña o una explosión con su ubicación, para que el mando reaccione a tiempo.",
  },
];

export const FUNCTIONAL = [
  { id: "F-01", text: "Identifica a una persona por su forma de caminar sobre video.", core: true },
  { id: "F-02", text: "Detecta y sigue personas dentro del cuadro de la cámara." },
  { id: "F-03", text: "Captura en los accesos del evento y arma la base temporal." },
  { id: "F-04", text: "Busca a una persona contra la base ya construida del evento." },
  { id: "F-05", text: "Cuenta personas y reporta aforo por zona." },
  { id: "F-06", text: "Avisa cuando una zona se acerca a su límite de aforo." },
  { id: "F-07", text: "Avisa contingencias: incendio, riña, explosión." },
  { id: "F-08", text: "Muestra la vista térmica e infrarroja en el centro de mando." },
  { id: "F-09", text: "Suma la vista aérea de los drones durante el evento." },
  { id: "F-10", text: "Elimina la base al cerrar el evento y entrega la constancia." },
];

// Fuera "< 200 ms" y "≥ 15 FPS": un análisis real tarda entre 12 y 27 minutos, y prometer esas
// cifras por escrito a un cliente de gobierno es el riesgo más grande de esta página.
export const SPECS = [
  { label: "Los datos viven solo durante el evento", value: "Temporal", icon: "Clock" },
  { label: "Se entrega comprobante de eliminación", value: "Borrado verificable", icon: "FileCheck2" },
  { label: "Cifrado en tránsito y en reposo", value: "AES-256", icon: "Lock" },
  { label: "Registro auditable de cada consulta", value: "Bitácora", icon: "ShieldCheck" },
  { label: "Identifica con el rostro cubierto", value: "Sin depender del rostro", icon: "Footprints" },
  { label: "Operación de noche y con humo", value: "Con sensor térmico", icon: "MoonStar" },
];

// Reemplaza el ROADMAP viejo ("demo a Fiscalía, julio 2026": fecha vencida y cliente que ya no
// corresponde). El corte Fase 1 / Fase 2 es el del contrato v2, pendiente de confirmación de
// Kevin; si cambia, se ajusta este bloque.
//
// ⚠️ SIN PLAZOS EN ESTA SECCIÓN (decisión de Diego, 6-ago). Decía "Ocho semanas" aquí y en el
// título de la sección. Ese plazo es el del contrato entre Zulunity y el cliente, y NO ha
// empezado a correr: arranca cuando se firma y se acredita el anticipo, y el contrato sigue
// abierto. Publicado en la página que el cliente le presenta a SU stakeholder, se lee como un
// compromiso ya vigente. No reponer fechas ni plazos aquí sin que el contrato esté firmado.
export const FASES = [
  {
    fase: "Hoy",
    title: "Identificación por forma de caminar, probada sobre video real",
    detalle: "Es lo que se ve funcionando en esta página.",
  },
  {
    fase: "Fase 1",
    title: "Centro de mando operativo + identificación por caminata",
    detalle:
      "Las vistas de térmica, contingencias y aglomeraciones entran como demostración dentro del centro de mando.",
  },
  {
    fase: "Fase 2",
    title: "Detección automática real y operación a escala",
    detalle:
      "Que térmica, contingencias y aglomeraciones detecten solas y en vivo, multi-cámara en los accesos y la base a escala de evento real.",
  },
  {
    fase: "Equipo",
    title: "Cámaras, sensor térmico y drones",
    detalle:
      "El hardware es del cliente. Nosotros entregamos el software que lo aprovecha.",
  },
];
